import { SignUpForm, SignUpHeader } from '@/AutoEnrollment/ui/organisms'
import { PageWrapper } from '@/Shared/ui/layout'

import { useMerchantAutoenrollmentInitController } from '../hooks/useMerchantAutoenrollmentInitController'

export const SignUpPage = (): JSX.Element => {
  useMerchantAutoenrollmentInitController()

  return (
    <PageWrapper style={{paddingTop: '0px'}}>
        <SignUpHeader />
        <SignUpForm />
    </PageWrapper>
  )
}
